module.exports = __webpack_public_path__ + "static/media/cleany-glazing.5ca88918.jpg";